export const MODAL_TYPE_CHOOSE_CATEGORY = 'choose-category';
